import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  .main-div {
    background-color: white;
    border-radius: 20px;
    padding-bottom: 20px;
    @media screen and (min-width: 768px) {
      /* height: calc(-100px + 100vh); */
    }
  }
`;

export const ContentSection = styled.div`
  padding: 20px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    max-width: auto;
    width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const IntroText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #555;
  margin-bottom: 24px;
  text-align: left;
`;

export const ProductGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ProductCard = styled.div`
  display: flex;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  height: 180px;
  max-width: 500px;
  cursor: pointer;
`;

export const ProductImageContainer = styled.div`
  flex: 0 0 40%;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  @media screen and (min-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

export const ProductInfo = styled.div`
  flex: 0 0 60%;
  padding: 10px 16px 5px 16px;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  background-color: white;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  border: 1px solid #e2e4e9;
`;

export const ProductBrand = styled.p`
  color: #1c9d87;
  font-weight: 500;
  margin: 0;
  margin-bottom: 4px;
`;

export const ProductName = styled.h3`
  font-size: 16px;
  margin: 0;
  margin-bottom: 8px;
  color: #142c1f;
`;

export const ProductDescription = styled.p`
  font-size: 16px;
  color: #7c7c7c;
  margin: 0;
  margin-bottom: 16px;
`;

export const ActionButton = styled.button`
  background-color: transparent;
  border: none;
  color: #1c9d87;
  font-weight: 500;
  text-align: left;
  padding: 0;
  font-size: 14px;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: 10px;

  &:hover {
    /* text-decoration: underline; */
  }
`;
